import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Subject, from } from 'rxjs';
import { debounceTime, switchMap } from 'rxjs/operators';
import { PAGES_AND_PATHS } from 'src/app/constants/pages-and-paths';
import { TlPagination } from 'src/app/interfaces/general-interfaces';
import { HomeService } from 'src/app/services/http-services/home/home.service';

@Component({
  selector: 'app-all-themes',
  templateUrl: './all-themes.component.html',
})
export class AllThemesComponent implements OnInit {
  pageNum = 1;
  pagination!: TlPagination;
  themes: any[] = [];
  private searchSubject = new Subject<string>();
  @ViewChild('themesContainer', { static: false }) private themesContainer!: ElementRef;
  loading = false;
  PAGES_AND_PATHS = PAGES_AND_PATHS;
  searchTerm = '';

  constructor(
    private homeHttpService: HomeService
  ) { }

  ngOnInit(): void {
    this.getAllThemes();
    this.searchSubject.pipe(
      debounceTime(300),
      switchMap((searchTerm: string) => from(this.getAllThemes(searchTerm)))
    ).subscribe(response => {
      this.themes = response.data;
      this.pagination = response.pagination;
    });
  }

  getAllThemes(searchTerm?: string) {
    this.loading = true;
    return from(
      this.homeHttpService.formattedGetAllThemes(this.pageNum, searchTerm).then((response: {
        data: Array<any>,
        pagination: TlPagination,
      }) => {
        this.themes = [...this.themes, ...response.data];
        this.pagination = response.pagination;
        this.loading = false;
        return response;
      })
    );
  }

  onScroll(): void {
    const container = this.themesContainer.nativeElement;
    const scrollTop = container.scrollTop;
    const scrollHeight = container.scrollHeight;
    const clientHeight = container.clientHeight;

    const isAtBottom = scrollTop + clientHeight >= scrollHeight - 100;

    if (!this.loading && isAtBottom && ((this.pagination?.currentPage ?? 0) < (this.pagination?.lastPage ?? 0))) {
      this.pageNum++;
      this.getAllThemes();
    }
  }

  onSearchChange(event: any): void {
    this.searchTerm = event.target.value;
    this.pageNum = 1;
    this.themes = [];
    this.searchSubject.next(this.searchTerm);
  }

  resetSearch(): void {
    this.searchTerm = '';
    this.searchSubject.next('');
  }
}
